module.exports = __webpack_public_path__ + "img/draft.b13515dd.svg";